<template>
  <div class="tw:flex tw:gap-4" v-if="store">
    <div class="tw:flex-none">
      <Store stroke-width="1" class="tw:size-12 tw:text-zinc-500" />
    </div>

    <div class="tw:min-w-0 tw:flex-1">
      <div class="tw:inline-flex tw:items-center tw:gap-1">
        <h3 class="tw:m-0 tw:text-base">
          {{ store.name }}
        </h3>
        <a
          v-if="store.links?.edit"
          :href="store.links.edit"
          target="_blank"
          class="tw:text-blue-600 p-1 rounded tw:hover:bg-zinc-100 tw:inline-flex tw:items-center tw:gap-1"
        >
          <span class="tw:sr-only">{{ $t("Edit") }}</span>
          <SquareArrowOutUpRight class="tw:size-3" />
        </a>
      </div>

      <div v-if="store.location" class="tw:flex tw:items-center tw:gap-1.5 tw:text-zinc-500">
        <MapPin class="tw:size-4 tw:flex-none" />
        <span class="tw:truncate">
          {{ store.location.address }} — {{ store.location.country_name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MapPin, SquareArrowOutUpRight, Store } from "@lucide/vue";

defineProps({
  store: {
    type: Object,
    default: null
  }
});
</script>
